<div class="material-return d-flex align-items-center gap-1 px-3 py-0 cursor-pointer" (click)="openMaterialReturn()">
    <fa-icon [icon]="faUndo"></fa-icon>
    <span class="d-none d-lg-block" translate="FREQUENT_ACTIVITIES_BUTTON_RETURN_MATERIAL_LABEL"></span>
    <span
        class="badge rounded-pill text-dark"
        [ngClass]="{
            'bg-success': numberOfMaterialsToBeReturned === 0,
            'bg-warning': numberOfMaterialsToBeReturned > 0,
        }"
        >{{ numberOfMaterialsToBeReturned }}</span
    >
</div>
